import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import { SelectedTab } from 'features/navbar/types'

/**
 * Resolves the display title for a workspace tab.
 * Page-published titles (`customLabel`) win; otherwise fall back to history.
 */
export function getWorkspaceTabLabel(tab: DocumentTab): string {
  if (tab.customLabel) return tab.customLabel

  const item = tab.history[tab.currentIndex]
  if (item.type === 'search') {
    const query = item.searchState.query.trim()
    if (query) return query
    if (
      tab.workspaceDestination === SelectedTab.Documents &&
      item.searchState.browseAll === true
    ) {
      return 'Documents'
    }
    if (item.searchState.searchMode === 'normal') return 'New Search'

    const hasAgenticConversation =
      (item.searchState.agenticSearch?.conversation.turns.length ?? 0) > 0
    return hasAgenticConversation ? 'Agentic Search' : 'New Tab'
  }

  if (item.type === 'destination' || item.type === 'timeseries') {
    return item.label
  }

  if (item.type === 'document') {
    const fromQuery = item.searchOriginQuery?.trim() || item.query.trim()
    if (fromQuery) return fromQuery
    return 'Document'
  }

  return 'New Tab'
}
